import mainPage from './main-page'
import regulation from './regulation'
import guide from './guide'
import post from './post'
import requiredDocs from './required-docs'
import askedQuestions from './asked-questions'
import contacts from './contacts'
import findOrgByDirection from './find-org-by-direction'
import appliedDocCountByOrg from './applied-doc-count-by-org'
import topics from '@/router/routes/front/topics'
import examProgramPresentation from '@/router/routes/front/exam-program-presentation'

export default [
  {
    path: '/',
    component: () => import('@/layouts/horizontal/LayoutHorizontal.vue'),
    children: [
      ...mainPage,
      ...regulation,
      ...guide,
      ...requiredDocs,
      ...askedQuestions,
      ...post,
      ...contacts,
      ...findOrgByDirection,
      ...topics,
      ...examProgramPresentation,
      // ...callCenter,
      ...appliedDocCountByOrg,
    ],
  },
]
